import { AuthContext } from "../context/AuthContext";
import { useAuth } from "../hooks/useAuth";
import { observer } from "mobx-react-lite";
import { RouterView } from "mobx-state-router";
import { viewMap } from "../routing/viewMap";
import AppState from "./AppState";
import Header from "./Header";
import { Container, Paper } from "@mui/material";
import { useRootStore } from "../hooks/useRootStore";
import Login from "./Login";
import { useCallback, useEffect } from 'react';

const Start = observer(() => {
    const { user, setUser } = useAuth();
    const { userProfile, routerStore, setActivityStartTime } = useRootStore();

    const handler = useCallback(() => {
        const ds = parseInt(localStorage.getItem('activityStartedAt') ?? 'not a number', 10);
        return setActivityStartTime(isNaN(ds) ? null : new Date((ds as number) * 1000));
    }, [setActivityStartTime]);

    useEffect(() => {
        document.addEventListener("visibilitychange", handler);
        return () => {
            document.removeEventListener("visibilitychange", handler);
        };
    }, [handler]);

    return (
        <AuthContext.Provider value={{ user, setUser }}>
            <Container maxWidth="xl" sx={{ display: "flex", flexDirection: "column", placeItems: "stretch", minHeight: "100vh", }}>
                {userProfile ? <Header /> : ''}
                <Paper sx={{ flex: 1, position: 'relative' }}>
                    {(userProfile
                        || routerStore.getCurrentRoute()?.name == 'resetpassword'
                        || routerStore.getCurrentRoute()?.name == 'requestresetpassword')
                        ? <RouterView viewMap={viewMap} /> : <Login />}
                </Paper>
                <AppState />
            </Container>
        </AuthContext.Provider>
    );
})

export default Start;